import type { PartType } from '../core/types';
import type { AnyPartDef } from './contract';
import { battery, button, buzzer, jumper, lamp, led, motor, resistor, slideSwitch, wire } from './defs';

export const PARTS: Record<PartType, AnyPartDef> = {
  battery,
  wire,
  jumper,
  lamp,
  switch: slideSwitch,
  button,
  motor,
  led,
  buzzer,
  resistor,
};

export const partDef = (type: PartType): AnyPartDef => PARTS[type];
